import styled from '@emotion/styled';

export const SelectedColorLabel = styled.div`
  color: #000000;
  font-family: 'OCRoboto';
  font-size: 16px;
  line-height: 18px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const SelectedColorName = styled.div`
  color: #000000;
  font-family: 'OCRoboto';
  font-size: 28px;
  line-height: 28px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 24px;
  }
`;

export const ColorDescription = styled.div`
  color: #000000;
  font-family: 'OCRoboto';
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
  margin: 0.75em 0px;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 1em;
  }
`;
